import IChildren from './children'
import IPupils from './pupils'

export enum IRole {
  parent = 'parent',
  educator = 'educator'
}
interface IUser {
  avatar_url: string
  children: IChildren
  pupils: IPupils
  email: string
  full_name: string
  parental_instructions_complete: boolean
  role: IRole
  terms_not_accepted?: boolean
}

export default IUser



// WEBPACK FOOTER //
// ./src/types/database/users/user/index.ts